import { render, staticRenderFns } from "./BusquedaClienteForDrawer.vue?vue&type=template&id=3aea6b5e"
import script from "./BusquedaClienteForDrawer.vue?vue&type=script&lang=js"
export * from "./BusquedaClienteForDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports